import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getGuid();
  const email = authService.getUserEmail();
  const code = authService.get2faCode();

  let headers: any = {};
  if (token) headers['x-api-token'] = token;
  if (email) headers['x-user-email'] = email;
  if (code) headers['x-2fa-code'] = code;

  if (Object.keys(headers).length > 0) {
    const cloned = req.clone({
      setHeaders: headers
    });
    return next(cloned);
  }

  return next(req);
};
